
	import useAuth from "@/store/AuthState";
	import useNotification from "@/store/NotificationState";
	import { defineComponent, ref } from "vue";
	import { useRoute, useRouter } from "vue-router";
	import NotificationsView from "./NotificationsView.vue";

	const NavBar = defineComponent({
		name: "NavBar",
		components: { NotificationsView },
		props: {
			name: {
				type: String,
				required: true,
			},
		},
		setup() {
			const nview = ref(null);
			const router = useRouter();
			const route = useRoute();
			const isHome = ref<boolean>(route.name === "dashboard");
			const { hasNewNotifications } = useNotification();
			function onClickBack() {
				router.back();
			}
			function onClickBell() {
				(nview.value! as typeof NotificationsView).open();
			}
			let toggleMenuBtn = ref(false);
			const { signOut } = useAuth();
			return { nview, onClickBell, onClickBack, isHome, toggleMenuBtn, signOut, hasNewNotifications };
		},
		// type inference enabled
	});
	export default NavBar;
